<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner inq">
                <div class="view mtb80">
                    <div class="form_box">
                        <div class="head">
                            <h2>{{ inquiry?.title }}</h2>
                            <div class="field">
                                <p>문의유형 <span>{{ inquiry?.type_name }}</span></p>
                                <p>성함 <span>{{ inquiry?.name }}</span></p>
                                <p>이메일 <span>{{ inquiry?.email }}</span></p>
                            </div>
                        </div>

                        <hr>

                        <div class="text">
                            <p>{{ inquiry?.content }}</p>
                        </div>

                    </div>
                    <div class="btns">
                        <button class="buttn" type="button" onclick="window.location.href='/inquire_history';">목록으로</button>
                    </div>
                    
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
import api from '@/api'
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
    name: 'InquireView',
    components: { TheHeader, TheFooter },

    data() {
        return {
            inquiry: null
        }
    },

    async mounted() {
        await this.checkLogin()
        await this.loadInquiry()
    },

    methods: {
        async checkLogin() {
            try {
                const res = await api.get('/admin/user-info', { withCredentials: true })
                if (!res.data || !res.data.loggedIn) {
                    this.redirectLogin()
                }
            } catch (e) {
                this.redirectLogin()
            }
        },

        async loadInquiry() {
            const id = this.$route.query.id
            if (!id) return

            try {
                const res = await api.get('/admin/inquiry_view', {
                    params: { id },
                    withCredentials: true
                })
                this.inquiry = res.data
            } catch (e) {
                console.error(e)
            }
        },

        redirectLogin() {
            const referer = this.$route.fullPath
            window.location.href = `/login_form?referer=${encodeURIComponent(referer)}`
        }
    }
}
</script>    